module.exports = __webpack_public_path__ + "media/images/easypin/remove-0520126025efc1c1ef6691cdbb7edb51.png";